<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=false><p slot="title">财务报表</p></sub-ibox-title>
		<!--<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar = "handleClickTabBar"></z-tab-bar>-->
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'Finance',
		components: {
		},
		data() {
			return {
				
			}
		},
		methods: {
		}
	}
</script>



// WEBPACK FOOTER //
// Index.vue?50c1f8fe